import { FallBackLoader } from './FallBackLoader';

export default FallBackLoader;
